function getHeaderValue(headers = {}, headerName = "") {
	const normalizedName = `${headerName || ""}`.toLowerCase();
	const matchingKey = Object.keys(headers || {}).find(key => `${key || ""}`.toLowerCase() === normalizedName);
	return matchingKey ? headers[matchingKey] : "";
}

function decodeXmlText(value = "") {
	return `${value || ""}`
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&quot;/g, "\"")
		.replace(/&apos;/g, "'")
		.replace(/&amp;/g, "&");
}

function getXmlElement(bodyText = "", elementName = "") {
	if (!bodyText || !elementName) {
		return "";
	}
	const match = new RegExp(`<${elementName}(?:\\s[^>]*)?>([\\s\\S]*?)</${elementName}>`, "i").exec(bodyText);
	return match ? decodeXmlText(match[1].trim()) : "";
}

function getBodyText(body) {
	if (body === undefined || body === null || body === "") {
		return "";
	}
	if (typeof body === "string") {
		return body;
	}
	try {
		return typeof body.toString === "function" ? body.toString() : `${body}`;
	} catch (_err) {
		return "";
	}
}

export function extractS3ResponseDiagnosticContext(response = {}) {
	const httpResponse = response.httpResponse || {};
	const responseHeaders = httpResponse.headers || {};
	const request = response.request || {};
	const httpRequest = request.httpRequest || {};
	const requestHeaders = httpRequest.headers || {};
	const endpoint = httpRequest.endpoint || {};
	const bodyText = getBodyText(httpResponse.body);

	return {
		httpStatus: httpResponse.statusCode || "",
		responseCode: getXmlElement(bodyText, "Code"),
		responseMessage: getXmlElement(bodyText, "Message"),
		expectedDigest: getXmlElement(bodyText, "ExpectedDigest"),
		calculatedDigest: getXmlElement(bodyText, "CalculatedDigest"),
		requestId: getXmlElement(bodyText, "RequestId") || getHeaderValue(responseHeaders, "x-amz-request-id") || "",
		extendedRequestId: getXmlElement(bodyText, "HostId") || getHeaderValue(responseHeaders, "x-amz-id-2") || "",
		bucketRegion: getXmlElement(bodyText, "Region") || getHeaderValue(responseHeaders, "x-amz-bucket-region") || "",
		endpointHostname: endpoint.hostname || "",
		endpointProtocol: endpoint.protocol || "",
		endpointPort: endpoint.port || "",
		httpMethod: httpRequest.method || "",
		requestPath: httpRequest.path || "",
		requestContentMd5: getHeaderValue(requestHeaders, "content-md5") || "",
		requestContentSha256: getHeaderValue(requestHeaders, "x-amz-content-sha256") || "",
		requestContentLength: getHeaderValue(requestHeaders, "content-length") || "",
		responseContentLength: getHeaderValue(responseHeaders, "content-length") || ""
	};
}
